'use client';

import React from 'react';
import { cn } from '@/lib/cn';

type CarouselUpdateDetail = {
  carouselId: string;
  currentIndex: number;
  slidesLength: number;
};

export interface CarouselCounterProps {
  carouselId: string;
  totalSlides?: number;
  initialIndex?: number;
  className?: string;
}

export function CarouselCounter({
  carouselId,
  totalSlides: totalSlidesProp,
  initialIndex = 0,
  className,
}: CarouselCounterProps) {
  const [currentIndex, setCurrentIndex] = React.useState(initialIndex);
  const [totalSlides, setTotalSlides] = React.useState(totalSlidesProp ?? 0);

  React.useEffect(() => {
    const handleCarouselUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<CarouselUpdateDetail>;
      if (customEvent.detail?.carouselId !== carouselId) return;

      setCurrentIndex(customEvent.detail.currentIndex);
      setTotalSlides(customEvent.detail.slidesLength);
    };

    document.addEventListener('carousel-update', handleCarouselUpdate);
    return () => {
      document.removeEventListener('carousel-update', handleCarouselUpdate);
    };
  }, [carouselId]);

  React.useEffect(() => {
    if (typeof totalSlidesProp === 'number') setTotalSlides(totalSlidesProp);
  }, [totalSlidesProp]);

  if (totalSlides <= 1) return null;

  return (
    <div
      className={cn(
        'pointer-events-none',
        'rounded-full bg-black/50 px-2 py-1',
        'text-caption text-inverted leading-[var(--line-height-line-height-xs)]',
        'whitespace-nowrap tabular-nums',
        className,
      )}
    >
      {currentIndex + 1} / {totalSlides}
    </div>
  );
}
